@use '@/scss/underscore' as _;

.container {
  display: flex;
  flex-direction: column;
  height: 100%;

  .cardTitle {
    flex-shrink: 0;
  }

  .tabs {
    margin: _.unit(4) 0;
  }

  .content {
    flex: 1;
    display: flex;
    flex-direction: column;

    .contentTop {
      display: flex;
      flex: 1;
      margin-bottom: _.unit(6);

      &.withSubmitActionBar {
        margin-bottom: _.unit(3);
      }

      .form {
        flex: 1;
        margin-right: _.unit(3);
      }

      .preview {
        flex: 1;
        position: sticky;
        top: _.unit(4);
        align-self: flex-start;
      }
    }
  }
}
